<template>
  <div>
    <el-dialog title="Хүргэлтийн дэлгэрэнгүй" :visible.sync="this.$root.deliveryDetailDialog" :before-close="handleClose" width="350px" center>
      <el-row>
          <el-col v-if="this.formData.phone">
            Утас: {{ this.formData.phone }}
          </el-col>
          <el-col v-if="this.formData.package_price">
            Багцын үнэ: {{ this.formData.package_price | formatCurrency()}}
          </el-col>
          <el-col v-if="this.formData.deliveryAmount">
            Хүргэлтийн үнэ: {{ this.formData.deliveryAmount | formatCurrency()}}
          </el-col>
          <el-col v-if="this.formData.totalAmount">
            Ачааны үнэ: {{ this.formData.totalAmount | formatCurrency() }}
          </el-col>
          <el-col v-if="this.formData.totalAmount || this.formData.deliveryAmount || this.formData.package_price">
            Нийт үнэ: {{ this.formData.totalAmount + this.formData.deliveryAmount + this.formData.package_price | formatCurrency() }}
          </el-col>
          <el-col v-if="this.formData.createdAt">
            Төлөвийн огноо: {{ this.formData.createdAt.split('T')[0] }}
          </el-col>
          <el-col v-if="this.formData.hvrgvvleh_ognoo">
            Хүргүүлэх огноо: {{ this.formData.hvrgvvleh_ognoo.split('T')[0] }}
          </el-col>
          <el-col v-if="formData.hvrgeltiin_ajiltan">
            Хүргэлтийн ажилтан: {{ this.formData.hvrgeltiin_ajiltan }}
          </el-col>
          <el-col v-if="formData.address_detail">
            Хүргүүлэх хаяг: {{ formData.address_detail }}
          </el-col>
          <el-col v-if="this.selectedDelivery.DeliveryDetail.length && this.selectedDelivery">
            <el-card v-for="item, index in this.selectedDelivery.DeliveryDetail" :key="index" class="mt-2 br-20 p-3" shadow="always" :body-style="{ padding: '0px' }">
              <el-row>
                <el-col :span="24" v-if="item.TrackCode.track_code" class="m-b-10">
                  <el-tag>{{item.TrackCode.track_code }}</el-tag>
                </el-col>
                <el-col v-if="item.TrackCode.taviur_code">
                  <span>Тавиур: {{item.TrackCode.taviur_code }}</span>
                </el-col>
                <el-col v-if="item.TrackCode.price_to_pay">
                  Үнэ: {{ item.TrackCode.price_to_pay | formatCurrency() }}
                </el-col>
                <el-col v-if="item.TrackCode.is_paid === 1">
                  <el-tag type="success" size="small">Төлбөр төлсөн</el-tag>
                </el-col>
                <el-col class="m-t-10" v-if="item.TrackCode.is_paid === 0">
                  <el-tag type="danger" size="small">Төлбөр төлөөгүй</el-tag>
                </el-col>
              </el-row>
            </el-card>
          </el-col><br><br>
          <el-col class="p-t-10">
            <el-button class="w-100" v-if="this.selectedDelivery.is_ready === false" size="small" type="primary" @click="isReady()">Бэлдэж дуусах</el-button>
            <div class="m-t-10">
              <el-button class="w-100" size="small" type="success" @click="openProgressDialog()">Үйлдэл</el-button>
            </div>
          </el-col>
      </el-row>
    </el-dialog>
    <ProgressDialog v-if="this.$root.progressDialog" :checkedTrackCodes="formData"></ProgressDialog>
  </div>
</template>

<script>
import services from '@/helpers/services'
import ProgressDialog from '@/views/Dialog/ProgressDialog.vue'

export default {
  data () {
    return {
      deliveryDetail: this.selectedDelivery,
      is_ready: true,
      id: this.selectedDelivery.id,
      formData: {
        phone: null,
        selectedTrackCodes: [],
        is_paid: null,
        paid_type: null,
        totalPrice: 0,
        taviur_codes: [],
        deliveryAmount: 0,
        description: '',
        type: 'delivery',
        not_paid_track_codes: [],
        address_detail: null,
        deliveries: [],
        no: 'no',
        hvrgvvleh_ognoo: null,
        totalAmount: 0,
        hvrgeltiin_ajiltan: null,
        address_id: null,
        delivery_price: 0,
        countTrackCode: 0,
        createdAt: null,
        package_price: 0
      }
    }
  },
  props: {
    selectedDelivery: {
      type: Object,
      default: () => ({})
    },
    taviur: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    ProgressDialog
  },
  created () {
    this.initData()
    this.amountSum()
    this.checkIsPaidStatus()
  },
  methods: {
    initData () {
      const c = this.selectedDelivery

      // props бүрэн ирсэн үед утга оноох
      if (c) {
        this.deliveryDetail = c
        this.id = c.id || null
        this.formData.deliveryAmount = c.delivery_price || 0
        this.formData.address = c.Address || []
        this.formData.deliveries = c || []
        this.formData.hvrgvvleh_ognoo = c.hvrgvvleh_ognoo || null
        this.formData.hvrgeltiin_ajiltan = c?.User?.lastName || null
        this.formData.address_detail = c?.Address?.detail_address || null
        this.formData.address_id = c?.Address?.id || null
        this.formData.phone = c.phone || null
        this.formData.countTrackCode = c.DeliveryDetail.length
        this.formData.createdAt = c.createdAt
        this.formData.package_price = c.package_price
      }
    },
    handleClose () {
      this.$root.deliveryDetailDialog = false
    },
    amountSum () {
      this.formData.totalAmount = this.selectedDelivery.DeliveryDetail.reduce((sum, element) => {
        return sum + (element?.TrackCode?.price_to_pay || 0)
      }, 0)
    },
    isReady () {
      try {
        this.$root.fullscreenLoading = true
        const payload = { id: this.id, is_ready: this.is_ready }
        services.changeIsReady(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.$root.fullscreenLoading = false
              this.$notify({
                title: 'Амжилттай',
                message: 'Төлөв амжилттай солигдлоо',
                type: 'success',
                duration: 3000
              })
              this.$root.deliveryDetailDialog = false
              this.$emit('refreshDeliveryList')
            } else {
              this.$root.fullscreenLoading = false
            }
          })
          .catch((error) => {
            console.error('Алдаа:', error)
            this.$root.fullscreenLoading = false
          })
      } catch (error) {
        alert(error)
        console.error('Алдаа:', error)
        this.$root.fullscreenLoading = false
      }
    },
    openProgressDialog () {
      this.formData.id = this.selectedDelivery.id
      this.formData.totalPrice = this.selectedDelivery.delivery_price + this.formData.totalAmount
      this.formData.selectedTrackCodes = this.selectedDelivery.DeliveryDetail.map(item => item.TrackCode?.track_code || '')
      this.formData.taviur_codes = this.selectedDelivery.DeliveryDetail.map(item => item.TrackCode?.taviur_code || '')
      this.$root.progressDialog = true
    },
    checkIsPaidStatus () {
      if (this.selectedDelivery.DeliveryDetail) {
        const allTrue = this.selectedDelivery.DeliveryDetail.every(item => item.TrackCode.is_paid === 1)
        const allFalse = this.selectedDelivery.DeliveryDetail.every(item => item.TrackCode.is_paid === 0)

        if (allTrue) {
          this.formData.is_paid = true
        } else if (allFalse) {
          this.formData.is_paid = false
        } else {
          this.formData.is_paid = null
          this.formData.not_paid_track_codes = this.selectedDelivery.DeliveryDetail
            .filter(item => item.TrackCode.is_paid === 0 || item.TrackCode.is_paid === false)
            .map(item => item.TrackCode)
        }
      }
    }
  }
}
</script>

  <style>

  </style>
